const ResponseError = require('./ResponseError');

class InvalidRequestError extends ResponseError {

}

module.exports = InvalidRequestError;
